import { useTypedTranslate } from 'providers/i18n/hooks/useTypedTranslate';
import { TextField } from 'shared/react-admin/Fields';
import { GatewayConversionListItem } from 'types/embedded/orderConversion';

import { StyledDatagrid } from './OrderConversionListDatagrid.styled';
import { OrderConversionListDatagridConversionField } from './OrderConversionListDatagridConversionField/OrderConversionListDatagridConversionField';
import { OrderConversionListDatagridTresholdsField } from './OrderConversionListDatagridTresholdsField';

type Props = {
  handleOpenCreateModal: (record: GatewayConversionListItem | undefined) => void;
  handleOpenEditModal: (record: GatewayConversionListItem | undefined) => void;
};

export const OrderConversionListDatagrid: React.FC<Props> = ({
  handleOpenCreateModal,
  handleOpenEditModal,
}) => {
  const translate = useTypedTranslate();

  return (
    <StyledDatagrid>
      <TextField label="ID" source="id" />
      <TextField label={translate('app.table.name')} source="name" />
      <OrderConversionListDatagridConversionField
        label={translate('app.orderConversion.conversion')}
      />
      <OrderConversionListDatagridTresholdsField
        cellClassName="column-tresholds"
        label={translate('app.orderConversion.thresholds')}
        onOpenCreateModal={handleOpenCreateModal}
        onOpenEditModal={handleOpenEditModal}
      />
    </StyledDatagrid>
  );
};
